import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { useStaticQuery, graphql } from "gatsby"
import $ from "jquery";
import TeamCard from "./TeamCard";
import "./Team.scss";

import {TeamFilter} from "../../common/queries/common_use_query"

const Team = ({Module, category}) => {

    const team_data = useStaticQuery(graphql`
    query TeamSliderQuery{
        glstrapi {
            teamsConnection(where: {publish:true}) {
                aggregate {
                    count
                }
            }

            teams(sort:"rank:asc",where:{publish:true}) {
                id
                name
                slug
                image {
                    alternativeText
                    url
                }
                title
                video_url
                mobile_no
                designation
                email
                content
                category
                show_on_teams
                imagetransforms
                ggfx_results {
                    id
                    content_type
                    transforms
                    src_import_url
                    src_cftle
                    field
                }
                offices {
                    id
                    name
                    slug
                }
            }
        }
    }`)
    
    var teams = team_data.glstrapi;

    const{loading, error, data} = TeamFilter(category);

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        mobileFirst: true,
        afterChange: (event) => {
            var activeDotEl = $('.team .slick-slider').find('.slick-dots').find('li.slick-active');
            if(activeDotEl.get(0)){
                activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
            
        },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    dots: false,
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots:true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots:true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },

        ],
    };

    let team_list = category ? data : teams

    return (
        <React.Fragment>
            {team_list?.teams?.length > 0 && 
            <section className="team">
                <Container>
                    <Row>
                        <Col>
                            <div className="team-wrapper">
                                <h2>{Module?.title}</h2>

                                
                                <Slider {...settings}>
                                    {team_list?.teams?.map((item, index) => {
                                        return(
                                            <TeamCard item={item} />
                                        )
                                    })
                                    }
                                </Slider>
  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            }
        </React.Fragment>
    );
};
export default Team;
